export const EMPLOYEE_REVIEWS_REPORT_LOAD = 'EMPLOYEE_REVIEWS_REPORT_LOAD'
export const EMPLOYEE_REVIEWS_REPORT_LOAD_PENDING = 'EMPLOYEE_REVIEWS_REPORT_LOAD_PENDING'
export const EMPLOYEE_REVIEWS_REPORT_LOAD_FULFILLED = 'EMPLOYEE_REVIEWS_REPORT_LOAD_FULFILLED'
export const EMPLOYEE_REVIEWS_REPORT_LOAD_REJECTED = 'EMPLOYEE_REVIEWS_REPORT_LOAD_REJECTED'

export const EMPLOYEE_REVIEWS_REPORT_RESET = 'EMPLOYEE_REVIEWS_REPORT_RESET'
